import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.apiKey.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.apiKey.fields.name'),
  },
  {
    name: 'permissions',
    label: i18n('entities.apiKey.fields.permissions'),
    render: exporterRenders.stringArray(),
  },
  {
    name: 'value',
    label: i18n('entities.apiKey.fields.value'),
  },
  {
    name: 'expiresAt',
    label: i18n('entities.apiKey.fields.expiresAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'requestsUsage',
    label: i18n('entities.apiKey.fields.requestsUsage'),
  },
  {
    name: 'requestsLimit',
    label: i18n('entities.apiKey.fields.requestsLimit'),
  },
  {
    name: 'bandwidthUsage',
    label: i18n('entities.apiKey.fields.bandwidthUsage'),
  },
  {
    name: 'allowedIPs',
    label: i18n('entities.apiKey.fields.allowedIPs'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.apiKey.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.apiKey.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
